export default __webpack_public_path__ + "static/media/amcharts.0d2e0eb2.png";